<template>
	<button class="star-btn" @click="clicked">
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<path
				:class="[ value ? 'fill-star-active' : 'fill-star' ]"
				d="M19.889 7.474c-.295-.942-1.099-1.552-2.047-1.552h-3.996a.574.574 0 0 1-.562-.402l-1.236-3.974C11.755.606 10.951 0 10 0c-.95 0-1.754.607-2.049 1.547L6.717 5.52a.575.575 0 0 1-.563.403H2.158c-.948 0-1.752.61-2.047 1.552-.296.947.01 1.934.781 2.516l3.233 2.44a.626.626 0 0 1 .215.686l-1.235 3.948c-.293.939.014 1.92.783 2.5.384.29.825.436 1.265.436.441 0 .882-.145 1.266-.435l3.233-2.44a.572.572 0 0 1 .696 0l3.233 2.44c.769.58 1.762.58 2.531 0 .77-.58 1.076-1.562.783-2.501l-.846-2.703a.775.775 0 0 0-.984-.52.818.818 0 0 0-.501 1.022l.845 2.702a.607.607 0 0 1-.215.687.557.557 0 0 1-.695 0l-3.233-2.44a2.084 2.084 0 0 0-2.532 0l-3.233 2.44a.557.557 0 0 1-.695 0 .607.607 0 0 1-.215-.687l1.235-3.947a2.28 2.28 0 0 0-.782-2.501L1.81 8.677c-.325-.245-.246-.599-.214-.701.032-.101.165-.43.561-.43h3.996c.94 0 1.763-.614 2.05-1.527l1.234-3.972A.574.574 0 0 1 10 1.623c.1 0 .44.03.562.423l1.235 3.974a2.147 2.147 0 0 0 2.049 1.525h3.996c.395 0 .53.33.561.43.032.103.111.457-.214.702l-2.204 1.664a.832.832 0 0 0-.173 1.133.763.763 0 0 0 1.091.18l2.205-1.664c.77-.582 1.077-1.569.78-2.516z"/>
		</svg>
	</button>
</template>
<script>

function clicked($event) {
	$event.stopPropagation();
	this.$emit('click', this.value);
}

export default {
	name: 'star-component',
	methods: {
		clicked,
	},
	props: {
		value: false,
	},
};
</script>
<style lang="scss" scoped>
	.star-btn {
		align-items: center;
		display: flex;
	}

	.fill-star {
		fill: transparent;
		stroke: color(dark);
		stroke-width: 1px;
	}

	.fill-star-active {
		fill: color(highLight);
	}
</style>




// WEBPACK FOOTER //
// src/components/shared/icons/star-component.vue